import { MacroInterfaces } from './MacroInterfaces';

export class MacroConfigDto {
  name: string;
  editorName: string;
  macroInterfaces: MacroInterfaces;
}
